// extracted by mini-css-extract-plugin
export default {"informationIconCircle":"styles-module__informationIconCircle--sYSEX","icon":"styles-module__icon--RUUeR"};